/**
 * The court system production statuses, used to help track the status of a court system internally
 */
export var ProductionStatus;
(function (ProductionStatus) {
    ProductionStatus["PreProduction"] = "preproduction";
    ProductionStatus["Sandbox"] = "sandbox";
    ProductionStatus["Production"] = "production";
    ProductionStatus["Archived"] = "archived";
    ProductionStatus["Historical"] = "historical";
})(ProductionStatus || (ProductionStatus = {}));
/**
 * Map the labels to human readable strings
 */
export const PRODUCTION_STATUS_LABELS = {
    [ProductionStatus.PreProduction]: 'Pilot',
    [ProductionStatus.Sandbox]: 'Sandbox',
    [ProductionStatus.Production]: 'Production',
    [ProductionStatus.Archived]: 'Archived',
    [ProductionStatus.Historical]: 'Historical',
};
